export const strings = {
  home: 'Ev',
  cases: 'Vakalar',
  review: 'Eleştiri',
  journals: 'Günlük',
  ':user_slug': 'Kullanıcı Detayları',
  ':case_slug': 'Vaka Detayları',
  ':journal_slug': 'Dergi Detayları',
  already_have_account: 'Zaten bir hesabınız var mı?',
  dont_have_account: 'Hesabınız yok mu?',
  signin_now: 'Şimdi giriş yap',
  signup_now: 'Şimdi üye ol!',
  analytics: 'Analitik',
  admin_dashboard: 'Yönetici Panosu',
  expert_dashboard: 'Uzman Panosu',
  contact_us: 'Teknik Destek',
  search: 'Aramak',
};
